import { useParsePaginationFromUrl } from '@app/hooks/useParsePaginationFromUrl';
import { ItemSortByOption, SortByTogglers } from '@components/SortByTogglers/SortByTogglers';
import { event } from '@marine/lib';
import { Grid } from 'antd';
import { useRouter } from 'next/router';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Pagination } from 'services/graphql/cms';
import styles from './SingleCollectionSortByTogglers.module.scss';

type Props = {
  pagination: Pagination;
};

const SingleCollectionSortByTogglers: FC<Props> = ({ pagination }) => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  const fromItemBoat = useMemo(() => pagination?.page * pagination?.pageSize, [pagination?.page, pagination?.pageSize]);

  const toItemBoat = useMemo(
    () => pagination?.page * pagination?.pageSize - pagination?.pageSize + 1,
    [pagination?.page, pagination?.pageSize],
  );

  const handleSortFilterChange = (orderBy) => {
    router.query.orderBy = `${orderBy.key}`;
    event({
      action: 'sort_by_changed',
      category: 'user_action',
      label: 'Sort by',
      value: orderBy.key,
    });

    router.push(
      { pathname: router.pathname, query: router.query },
      { pathname: router.pathname, query: router.query },
      { shallow: true },
    );
  };

  const { xs } = Grid.useBreakpoint();

  const pagesCount = useMemo(() => {
    if (fromItemBoat < pagination?.total) {
      return fromItemBoat;
    }

    return pagination?.total;
  }, [fromItemBoat, pagination?.total]);

  const sortByOptions: ItemSortByOption[] = [
    {
      isSelected: false,
      key: 'RECENTLY_ADDED',
      title: 'Recently added',
    },
    {
      isSelected: false,
      key: 'MOST_VIEWED',
      title: 'Most viewed',
    },
    {
      isSelected: false,
      key: 'A_TO_Z',
      title: 'AZ',
    },
  ];

  const { orderBy } = useParsePaginationFromUrl();

  return (
    <div className={styles.containerFilter}>
      <SortByTogglers
        onItemSelect={handleSortFilterChange}
        options={sortByOptions}
        title="SortBy"
        selectedOptionKey={orderBy || 'RECENTLY_ADDED'}
      />
      <div className={styles.containerInfo}>
        <div className={styles.boatViews}>
          <p>
            {formatMessage(
              {
                id: 'explore_boats.viewing',
              },
              {
                currentPage: toItemBoat,
                pagesCount,
                totalCount: pagination?.total,
                break: xs && <br />,
              },
            )}
          </p>
        </div>

        {/* {!lg && (
          <div className={styles.boatFilter}>
            {filterCount !== 0 && (
              <Button
                className={styles.boatClear}
              >
                {formatMessage(
                  {
                    id: 'explore_boats.clear',
                  },
                  {
                    icon: <CloseOutlined />,
                    count: filterCount,
                  },
                )}
              </Button>
            )}

            <Button
              className={`${styles.buttonFilter} ${filterCount !== 0 ? styles.buttonFilterActive : ''}`}
              onClick={() => {
                setCollapsed(true);
              }}
            >
              {xs ? (
                <>
                  <FilterOutlined />
                  {' '}
                  (
                  {filterCount}
                  )
                </>
              ) : (
                formatMessage(
                  {
                    id: 'explore_boats.filter',
                  },
                  {
                    icon: <FilterOutlined />,
                    count: filterCount !== 0 ? `(${filterCount})` : '',
                  },
                )
              )}
            </Button>
          </div>
        )} */}
      </div>
    </div>
  );
};

export { SingleCollectionSortByTogglers };
